
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('image',{attrs:{"width":"28","height":"28","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAIGNIUk0AAHomAACAhAAA+gAAAIDo AAB1MAAA6mAAADqYAAAXcJy6UTwAAABjUExURQAAAP////////////////////////////////// //////Dy98XO3/j5+5mpyIudwKGvzKi10K+71PHz977I3MzU5M3U47fC2OLm7+ns877I27bB15Kj xKCvzKi1z5qpyAAAABxJaQ8AAAAKdFJOUwBAj9/PnyAQkD+yeUh8AAAAAWJLR0QAiAUdSAAAAAlw SFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB+cMBAM5IyOiuV0AAACvSURBVCjPhdLrEoIgEIbhdQWx 9UBFByrL+7/LJE+UfNP7R4dnEGZcoqGMc/lK6YLGTCmJ2HxMSTIVtBQQExUCy0hjZJpPrOqQVM2K Oc1vrQ1JvY90QTuhjXSLkSbQHgBGB27xON45jdPHE+hO58vVAfQ3EecB3sPzAbBrvJcOoH227Qtd CN+2X61fcB4tVy+5aUkR45+tKcM4jCfcyv9Gk0xy7zjUQ4X+2Z3zLqy/AZQWICnhmTSRAAAAJXRF WHRkYXRlOmNyZWF0ZQAyMDIzLTEyLTA0VDAyOjMyOjE0KzAwOjAwNaideAAAACV0RVh0ZGF0ZTpt b2RpZnkAMjAyMy0xMi0wNFQwMjozMjoxNCswMDowMET1JcQAAAAodEVYdGRhdGU6dGltZXN0YW1w ADIwMjMtMTItMDRUMDM6NTc6MzUrMDA6MDAkuNBQAAAAAElFTkSuQmCC"}})])
          )
        }
      }
    